import React from 'react'
import  { Table }  from 'antd';
import { DivList } from '../styles';
import customExpandIcon from './customExpandIcon'

interface Props {
    data: Array<Object>
    columns: Array<object> 
    style: object
}

function listTable({data = [], columns = [], style = {}}:Props): JSX.Element {
    
    if(columns && columns.length > 0){
        columns[0].fixed = 'left'
        columns[0].width = 250
    }

    return (
        <DivList style={style}>
            <Table 
                scroll={{y:'100%'}}
                pagination={false}
                dataSource={data} 
                rowKey={"id"}
                columns={columns}                                
                expandRowByClick={true}
                expandable={{
                    defaultExpandAllRows: false,
                    expandIcon: (props) => customExpandIcon(props)
                }}
                className="intelie-style"
            />
        </DivList>
    )
}

export default listTable
